import lineChartAdapter from './line';
import areaChartAdapter from './area';
import donutChartAdapter from './donut';
import pieChartAdapter from './pie';
import bubbleChartAdapter from './bubble';
import scatterChartAdapter from './scatter';
import barChartAdapter from './bar';
import horizontalBarChartAdapter from './horizontalBar';
import doubleBarChartAdapter from './doubleBar';
import stackedBarChartAdapter from './stackedBar';
import gaugeChartAdapter from './gauge';
import radarChartAdapter from './radar'; // Map chart adapter type to its adapter

const CHART_ADAPTERS = {
  Line: lineChartAdapter,
  Area: areaChartAdapter,
  Donut: donutChartAdapter,
  Pie: pieChartAdapter,
  Bubble: bubbleChartAdapter,
  Scatter: scatterChartAdapter,
  Bar: barChartAdapter,
  HorizontalBar: horizontalBarChartAdapter,
  DoubleBar: doubleBarChartAdapter,
  StackedBar: stackedBarChartAdapter,
  Gauge: gaugeChartAdapter,
  Radar: radarChartAdapter
};
export const getChartAdapter = type => {
  return CHART_ADAPTERS[type];
};
export default CHART_ADAPTERS;